<template>
  <svg width="160"
       height="32"
       viewBox="0 0 160 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <rect width="32"
          height="32"
          rx="16"
          fill="#F0F3F3" />
    <rect width="116"
          height="12"
          transform="translate(44 10)"
          fill="#F0F3F3" />
  </svg>
</template>
